module.exports = __webpack_public_path__ + "static/media/emark-logo-new.bd90c365.png";